.shortlistButton {
  border-radius: 6px;
  line-height: 22px;
  margin-right: 10px;

  svg {
    margin-right: 6px;
  }
}
